var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-center-wrapper" },
    [
      _c(
        "layout",
        [
          _c("center-head", { attrs: { slot: "lt" }, slot: "lt" }),
          _vm._v(" "),
          _c("depth", { attrs: { slot: "r" }, slot: "r" }),
          _vm._v(" "),
          _c("market", { attrs: { slot: "lb1" }, slot: "lb1" }),
          _vm._v(" "),
          _c("center-view", { attrs: { slot: "lb2" }, slot: "lb2" }),
          _vm._v(" "),
          _c("latest-tx", { attrs: { slot: "lb3" }, slot: "lb3" }),
          _vm._v(" "),
          _c("limit-price", { attrs: { slot: "lb4" }, slot: "lb4" })
        ],
        1
      ),
      _vm._v(" "),
      _c("order-tab", { staticClass: "order-tab" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }